module.exports = __webpack_public_path__ + "img/title.df000c06.png";